const services = [
    {
        icon: "🖥️",
        title: "Applications web sur mesure",
        desc: "Des outils métier conçus pour vos besoins spécifiques : gestion, commandes, réservations, tableaux de bord, automatisation.",
    },
    {
        icon: "🌐",
        title: "Sites internet",
        desc: "Sites vitrines, landing pages, sites e-commerce. Design moderne, rapide, responsive et optimisé pour le référencement.",
    },
    {
        icon: "📱",
        title: "Applications installables sur mobile",
        desc: "Des applications installables directement depuis le navigateur, sans passer par les stores. Fonctionnent sur mobile et desktop (PWA).",
    },
    {
        icon: "🔧",
        title: "Maintenance & évolution",
        desc: "Votre application évolue avec votre activité. Mises à jour, nouvelles fonctionnalités, support technique réactif.",
    },
];

export function Services() {
    return (
        <section id="services" className="scroll-mt-20 py-10 px-6">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-3xl sm:text-4xl font-bold text-center text-[#1a3660] mb-4">
                    Ce que nous <span className="text-[#f07020]">construisons</span>
                </h2>
                <p className="text-slate-500 text-center max-w-2xl mx-auto mb-10">
                    Du site vitrine à l'application métier complexe, nous maîtrisons toute la chaîne.
                </p>
                <div className="grid sm:grid-cols-2 gap-5">
                    {services.map((s) => (
                        <div
                            key={s.title}
                            className="flex gap-5 p-6 rounded-2xl border border-slate-100 hover:border-[#f07020]/20 hover:shadow-sm transition-all"
                        >
                            <span className="text-3xl shrink-0">{s.icon}</span>
                            <div>
                                <h3 className="text-lg font-bold text-[#1a3660] mb-1">{s.title}</h3>
                                <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
